import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CallIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M10.5895 14.95L8.81663 16.8C8.44288 17.19 7.84871 17.19 7.46538 16.81C7.35996 16.7 7.25454 16.6 7.14913 16.49C6.16204 15.45 5.27079 14.36 4.47538 13.22C3.68954 12.08 3.05704 10.94 2.59704 9.81C2.14663 8.67 1.91663 7.58 1.91663 6.54C1.91663 5.86 2.03163 5.21 2.26163 4.61C2.49163 4 2.85579 3.44 3.36371 2.94C3.97704 2.31 4.64788 2 5.35704 2C5.62538 2 5.89371 2.06 6.13329 2.18C6.38246 2.3 6.60288 2.48 6.77538 2.74L8.99871 6.01C9.17121 6.26 9.29579 6.49 9.38204 6.71C9.46829 6.92 9.51621 7.13 9.51621 7.32C9.51621 7.56 9.44913 7.8 9.31496 8.03C9.19038 8.26 9.00829 8.5 8.77829 8.74L8.04996 9.53C7.94454 9.64 7.89663 9.77 7.89663 9.93C7.89663 10.01 7.90621 10.08 7.92538 10.16C7.95413 10.24 7.98288 10.3 8.00204 10.36C8.17454 10.69 8.47163 11.12 8.89329 11.64C9.32454 12.16 9.78454 12.69 10.2829 13.22C10.3787 13.32 10.4841 13.42 10.58 13.52C10.9633 13.91 10.9729 14.55 10.5895 14.95Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M21.0545 18.33C21.0545 18.61 21.0066 18.9 20.9108 19.18C20.882 19.26 20.8533 19.34 20.8149 19.42C20.652 19.78 20.4412 20.12 20.1633 20.44C19.6937 20.98 19.1762 21.37 18.5916 21.62C18.582 21.62 18.5725 21.63 18.5629 21.63C17.9975 21.87 17.3841 22 16.7229 22C15.7454 22 14.7008 21.76 13.5987 21.27C12.4966 20.78 11.3945 20.12 10.302 19.29C9.92828 19 9.55453 18.71 9.19995 18.4L12.3337 15.13C12.602 15.34 12.8416 15.5 13.0429 15.61C13.0908 15.63 13.1483 15.66 13.2154 15.69C13.292 15.72 13.3687 15.73 13.455 15.73C13.6179 15.73 13.7425 15.67 13.8479 15.56L14.5762 14.81C14.8158 14.56 15.0458 14.37 15.2662 14.25C15.4866 14.11 15.707 14.04 15.9466 14.04C16.1287 14.04 16.3204 14.08 16.5312 14.17C16.742 14.26 16.9625 14.39 17.202 14.56L20.3741 16.91C20.6233 17.09 20.7958 17.3 20.9012 17.55C20.997 17.8 21.0545 18.05 21.0545 18.33Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_3)
  ]))
}
}

})